import React, { createContext, useState } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { theme } from 'theme';

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1501,
    color: theme.colors.primary.red,
  },
}));
const LoaderContext = createContext();

const LoaderContextProvider = ({ children, minHeight = '120px' }) => {
  //Hooks
  const classes = useStyles();

  //State
  const [isLoaderActive, setLoaderActive] = useState(false);

  return (
    <LoaderContext.Provider value={{ isLoaderActive, setLoaderActive }}>
      <div style={{ minHeight: `calc(100vh - ${minHeight})` }}>{children}</div>
      <Backdrop className={classes.backdrop} open={isLoaderActive}>
        <CircularProgress color={'inherit'} />
      </Backdrop>
    </LoaderContext.Provider>
  );
};

export { LoaderContextProvider, LoaderContext };
